import { render, staticRenderFns } from "./AdicionarFornecedor.vue?vue&type=template&id=eefa261e&scoped=true&"
import script from "./AdicionarFornecedor.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdicionarFornecedor.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefa261e",
  null
  
)

export default component.exports